import React, {useEffect, useState} from 'react';


import 'react-checkbox-tree/lib/react-checkbox-tree.css';

import {DebounceInput} from 'react-debounce-input';
import {useLazyQuery} from "@apollo/client";
import {BLOG_SEARCH} from './../../queries/blogSearch';
import {BLOG} from '../../queries/blog';
import {BLOGS_COUNT} from '../../queries/blogsCount';
import axios from 'axios';
import { data } from 'jquery';
import InfinitProgressBar from '../../components/InfiniteProgressBar';


const SidebarForBlog = (props) => {

const [blogSearch, blogData] = useLazyQuery(BLOG_SEARCH, {
    variables: { searchText: `{ from:${(props.blogPagination.currentPage - 1) * props.blogPagination.blogsPerPage}, size:${props.blogPagination.blogsPerPage}, culture:"fa-ir", fulltext: "${props.blogPagination.searchText}"}` , skip: (props.blogPagination.currentPage - 1) * props.blogPagination.blogsPerPage, first: props.blogPagination.blogsPerPage }
});
const [blogsCount, blogsCountData] = useLazyQuery(BLOGS_COUNT);
  const [blogAll, blogAllData] = useLazyQuery(BLOG, {
    variables: { skip: (props.blogPagination.currentPage - 1) * props.blogPagination.blogsPerPage, first: props.blogPagination.blogsPerPage }
  });

  
  
const searchHandler = (e) => {
    props.searchPhraseSetter(e.target.value ? `${e.target.value}` : "");  
    props.currentPageSetter(1); 
  };
  useEffect(() => {
    props.blogPagination.currentPage = props.currentPage;
    const s = `${props.searchPhrase}`;
    if (s && s.trim()) {
        props.blogPaginationSetter({blogs: ( []), currentPage: props.currentPage, blogsPerPage: 6, searchText: s });
        blogSearch().then((d) => {
            if(d.loading) return <InfinitProgressBar/>
            if(d.error) return <div>error!</div>
            props.blogPaginationSetter({blogs: (d ? d.data.searchBlog : []), currentPage: props.currentPage, blogsPerPage: 6, searchText: s });
            return d;
        }).then((r) => {
            axios({
                url:`/api/queries/searchBlog?parameters={"from" :${0}, "size" : ${1} ,"culture": "fa-ir", "fulltext" :  "${s}"}`,
                method:"get"
            })
            .then(result => {  
                              
                props.blogPaginationSetter({blogs: (r ? r.data.searchBlog : []), currentPage: props.currentPage, blogsPerPage: 6, searchText: s, total: result.data.count }) 
                //props.productPaginationSetter({total: result.data.count});
                
                
            })
        });
    } else {
        blogAll().then((d) => {
            if(d.loading) return <InfinitProgressBar/>
            if(d.error) return <div>error!</div>
            return d;
        }).then((r) => {
            blogsCount()
            .then(result => {  
                if(result.loading) return <InfinitProgressBar/>
                if(result.error) return <div>error!</div>
                props.blogPaginationSetter({blogs: (r && r.data ? r.data.blog : []),currentPage: props.currentPage, blogsPerPage: 6, searchText: "", total: result.data.blogsCount[0].blogCount }) 
                
            })
        });
    }
  }, [props.searchPhrase, props.currentPage])
  
  
      return (
        <div style={{width:'350px', height:"100%", display:'flex', flexDirection:'column'}} >
            <div style={{width:'100%', height:"auto", display:'flex', flexDirection:'column'}}>
                <p>جستجوی وبلاگ:</p>
                <DebounceInput
          minLength={1}
          debounceTimeout={300} 
                style={{width:'70%', height:"40px", padding:'2%', border:'ipx solid lightgray', borderRadius:'20px', outline:'none'}} 
                onChange={(e) => searchHandler(e)}
                
                />
            </div>
            <br/>
            <hr style={{width:'100%', height:"2px", color:"#e5e5e5", backgroundColor:'#e5e5e5'}}/>
        
        </div>
    );
}

export default SidebarForBlog;
